<template>
<router-link :to="{ path: '/profile/'+ user.id }">
    <v-tooltip top :disabled="disableTip">
        <v-avatar :class="avatarColor" slot="activator" :size="size">
            <img :src="user.group_photo.avatar" v-if="user.group_photo" />
            <img :src="user.profile_photo.avatar" v-if="hasAvatar" />
            <span class="white--text" :style="scaledFont" v-else>{{user.initials}}</span>
        </v-avatar>
        <span v-if="user.display_name">{{user.display_name}}</span>
        <span v-if="user.name">{{user.name}}</span>
    </v-tooltip>
</router-link>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  props: ["user", "size", "hideTip", "spacing"],
  data() {
    return {};
  },
  computed: {
    disableTip() {
      if (typeof this.hideTip !== "undefined") {
        return this.hideTip === "true";
      } else {
        return false;
      }
    },
    hasAvatar() {
      if (typeof this.user.profile_photo === "undefined") {
        return false;
      }
      if (typeof this.user.profile_photo.avatar === "undefined") {
        return false;
      }
      return true;
    },
    scaledFont() {
      return "font-size: " + Math.floor(parseInt(this.size, 10) * 0.4) + "px";
    },
    avatarColor() {
      let c =
                this.user.initials
                  .substr(0, 1)
                  .toUpperCase()
                  .charCodeAt(0) % 10;
      let returnColor = "";
      switch (c) {
        case 0:
          returnColor = "light-blue darken-3";
          break;
        case 1:
          returnColor = "red darken-2";
          break;
        case 2:
          returnColor = "pink darken-3";
          break;
        case 3:
          returnColor = "purple darken-3";
          break;
        case 4:
          returnColor = "indigo darken-2";
          break;
        case 5:
          returnColor = "blue darken-4";
          break;
        case 6:
          returnColor = "light-blue darken-3";
          break;
        case 7:
          returnColor = "cyan darken-3";
          break;
        case 8:
          returnColor = "green darken-2";
          break;
        case 9:
          returnColor = "deep-orange darken-3";
          break;
      }

      if (typeof (this.spacing) !== "undefined") returnColor = returnColor + " " + this.spacing;

      return returnColor;
    }
  },
  methods: {},
  mounted() {}
};
</script>
